import { Injectable } from '@angular/core';
import { constrainPoint } from '@fullcalendar/core/internal';
import { AppService } from '../app/app.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ImageDataDetail } from 'src/app/model/common-model';
import { AlertComponent } from 'src/app/pages/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';


@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private titleSubject = new BehaviorSubject<string>('')
  public title = this.titleSubject.asObservable()
  private imageData: ImageDataDetail = {
    certificate: { minWidth: 150, maxWidth: 1025, minHeight: 150, maxHeight: 1025, size: 5 },
    playlist: { minWidth: 150, maxWidth: 1025, minHeight: 150, maxHeight: 1025, size: 50 }
  }
  private dataSubject = new BehaviorSubject<string>('Initial Value');
  public data$ = this.dataSubject.asObservable();

  public acceptTermsSubject=new BehaviorSubject<string>('');
  public acceptData$=this.acceptTermsSubject.asObservable()

  private retrySubject = new Subject<void>();
  retry$ = this.retrySubject.asObservable();

  constructor(private appService: AppService, private router: Router,private dialog:MatDialog) { }
  // function to convert object into Form Data
  updateSidebarData(newValue: string) {
    this.dataSubject.next(newValue);
  }
  onBuyCourses(newValue: string){
    this.acceptTermsSubject.next(newValue)
  }

  convertToFormData(obj: any): FormData {
    const formData = new FormData();
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      }
    }
    return formData;
  }
  validateImage(file: File, type): Promise<boolean> {
    const image = new Image();
    image.src = URL.createObjectURL(file);

    let validDimensions = false;
    let validSize = true;
    let validName = false;
    // Check image dimensions
    let imageType = type
    return new Promise<boolean>((resolve) => {
      image.onload = () => {
        const width = image.width;
        const height = image.height;
        const size = Math.round(file.size / 1024) // size in kb;
        if ((width >= this.imageData[imageType]["minWidth"] && width <= this.imageData[imageType]["maxWidth"]) &&
          (height >= this.imageData[imageType]["minHeight"] && height <= this.imageData[imageType]["maxHeight"])) {
          validDimensions = true
        }
        if (size > this.imageData[imageType]["size"]) {
          validSize = false;
        }
        validName = true
        resolve(validDimensions && validSize && validName);
      };
    })
  }
  managerRedirect(userType: string) {
    if (this.appService.getSessionData('deepLinkData')) {
      let dataObj = JSON.parse(this.appService.getSessionData('deepLinkData'))
      if (userType == 'company') {
        this.manageCompanyRedirect()       
      }
      else if (userType == 'manager') {
        this.router.navigate(['/manager/dashboard'])
      }
      else {
        if (JSON.stringify(dataObj) != "") {
          if (dataObj["t"] == 'co') {
            this.router.navigate(['/individual/dashboard/course-detail'], { queryParams: { c_i: dataObj["id"], t: "d_cs" } })
          }
          if (dataObj["t"] == 'off') {
            let queryData = {
              id: dataObj["id"],
              type: "offer"
            }
            this.router.navigate(['/individual/dashboard/offer-detail'], { queryParams: queryData })
          }
          if (dataObj["t"] == 'aff') {
            let queryData = {
              id: dataObj["id"],
              type: "affiliate",
            }
            if(dataObj.hasOwnProperty("typ")){
             queryData["typ"]=dataObj["typ"]
            }
            this.router.navigate(['/individual/dashboard/offer-detail'], { queryParams: queryData })
          }
          if (dataObj["t"] == 'pac') {
            let queryData = {
              id: dataObj["id"],
              type: "package",
              // p_t:dataObj["package_type"]
            }
            this.router.navigate(['/individual/dashboard/offer-detail'], { queryParams: queryData })
          }
        }
        else {
          this.router.navigate(['/individual/dashboard'])
        }

      }
      // this.appService.removeSessionData('deepLinkData')
    }
    else {
      if (userType == 'company') {
        // this.router.navigate(['/package/offer-package'])
        this.manageCompanyRedirect()       
      }
      else if (userType == 'manager') {
        this.router.navigate(['/manager/dashboard'])
        // this.router.navigate(['/manager/employee-management'])
      }
      else if (userType == 'individual') {
        this.router.navigate(['/individual/dashboard'])
      }
      else  {
        this.appService.removeData('training-portal.userInfo')
        this.router.navigate(['/authentication/signin'])
      }
    }
  }
  manageCompanyRedirect(){
    let userData = JSON.parse(this.appService.getData('training-portal.userInfo'))
    if(userData["t_off"]==0){
      this.router.navigate(['/package/offer-package'])
    }
    else{
      
      // this.router.navigate(['/user-management'])
      this.router.navigate(['/dashboard/dashboard2'])
    }
  }
  setTitle(value: string) {
    this.titleSubject.next(value)
  }
  public handleError = (error: HttpErrorResponse) => {
    if (error.status === 500) {
      this.router.navigate(['/authentication/page500']);
    }
    else if (error.status === 404) {
      this.router.navigate(['/authentication/page404']);
    }
    else if (error.status === 404) {
      this.router.navigate(['/authentication/page404']);
    }
    else {
    }
  }
  
  callAlert(){
    const dialogRef = this.dialog.open(AlertComponent, Object.assign({
      disableClose:true,
      data: { api_type: 'error', }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.retrySubject.next();
      }
    });
  }
}
